<template>
  <section class="card">
    <div class="card-header">
      <div class="utils__title">
        <strong>Výrobci - Upravit <span class="utils__link--underlined text-primary">#{{ this.id }}</span></strong>
      </div>
      <action-tools :router-options="routerOptions"></action-tools>
    </div>
    <div class="card-body">
      <div class="table-operations">
        <language-tab></language-tab>
      </div>
      <a-form :form="form" @submit="handleSubmit">
        <h4 class="text-black mt-4 mb-3"><strong>Nastavitelné podle jazyka</strong></h4>
        <a-form-item
          label="Popisek"
          :validate-status="error('mle_description') ? 'error' : ''"
          :help="error('mle_description') || ''"
        >
          <a-input
            :autoSize="{ minRows: 4, maxRows: 10 }"
            type="textarea" placeholder="Popisek" v-decorator="['mle_description']"/>
        </a-form-item>

        <h4 class="text-black mt-4 mb-3"><strong>Ostatní</strong></h4>

        <a-form-item
          label="Název"
          :validate-status="error('mur_name') ? 'error' : ''"
          :help="error('mur_name') || ''"
        >
          <a-input placeholder="Název" v-decorator="['mur_name', {rules: [{max: 100, message: 'Název nemůže být delší než 100 znaků!'}, {required: true, message: 'Název musí být vyplněn!'}]}]"/>
        </a-form-item>

        <a-form-item
          label="URL"
          :validate-status="error('mur_url') ? 'error' : ''"
          :help="error('mur_url') || ''"
        >
          <a-input placeholder="URL" v-decorator="['mur_url', {rules: [{type: 'url', message: 'URL není ve správném formátu!'}, {max: 200, message: 'URL nemůže být delší než 200 znaků!'}]}]"/>
        </a-form-item>

        <a-form-item>
          <span slot="label">
            Logo výrobce
            <a-tooltip title="Můžete si vybrat z již existujících obrázků.">
              <a-icon type="question-circle-o"/>
            </a-tooltip>
          </span>
          <small>Logo výrobce již existuje v systému:&nbsp;</small>
          <a-switch checkedChildren="Ano" unCheckedChildren="Ne" v-model="image.switch" @change="onImageSwitchChange"/>
          <div v-if="this.image.switch">
            <a-row class="pb-5" type="flex" justify="center">
              <a-col :span="8">
                <a-input-search
                  placeholder="Hledat..."
                  v-model="image.search"
                />
              </a-col>
            </a-row>
            <div v-if="images.data.length > 0">
              <a-row>
                <a-radio-group v-decorator="['existing']" name="image" :class="$style.gallery">
                  <a-col v-if="item.iae_id.existing !== null" :xl="4" :md="6" :sm="8" :xs="12">
                    <div :class="{[$style.active]: item.iae_id.existing.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                      <img v-if="!image.errors.includes(item.iae_id.existing.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_id.existing.iae_path + '_6.' + item.iae_id.existing.iae_format" @error="image.errors.push(item.iae_id.existing.iae_id)">
                      <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                      <div :class="$style.itemControls">
                        <span :class="$style['item-name']">{{ toImageName(item.iae_id.existing.iae_name) }}</span>
                        <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id.existing.iae_id" checked/>
                      </div>
                    </div>
                  </a-col>
                  <a-col :key="index" v-for="(item, index) in images.data" :xl="4" :md="6" :sm="8" :xs="12">
                    <div :class="{[$style.active]: item.iae_id === form.getFieldValue('existing'), [$style.item]: 1 === 1, [$style.withControls]: 1 === 1}">
                      <img v-if="!image.errors.includes(item.iae_id)" class="img-fluid" :src="$uploadImagePath + item.iae_path + '_6.' + item.iae_format" @error="image.errors.push(item.iae_id)">
                      <a-icon v-else theme="twoTone" twoToneColor="#ccc" type="frown" />
                      <div :class="$style.itemControls">
                        <span :class="$style['item-name']">{{ toImageName(item.iae_name) }}</span>
                        <a-radio :class="$style['ant-radio-wrapper']" :value="item.iae_id"/>
                      </div>
                    </div>
                  </a-col>
                </a-radio-group>
              </a-row>
              <a-row class="pb-5 pt-5" type="flex" justify="center">
                <a-col :span="8">
                  <a-button v-if="imageNextCount > 0" type="primary" class="width-200 d-block m-auto" @click="onNextImagesClick">Načíst další...</a-button>
                </a-col>
              </a-row>
            </div>
            <a-empty v-else>
              <a-spin v-if="!image.loaded" />
            </a-empty>
          </div>
          <a-upload-dragger
            v-else
            :fileList="this.item.iae_id.new"
            name="file"
            :multiple="false"
            :beforeUpload="beforeUpload"
            :remove="handleRemove"
            :disabled="this.image.switch"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox"/>
            </p>
            <p class="ant-upload-text">Chcete-li nahrát soubor, klikněte nebo přetáhněte soubor do této oblasti</p>
          </a-upload-dragger>
        </a-form-item>

        <div class="form-actions">
          <a-button html-type="submit" type="primary" :disabled="loading || hasErrors(form.getFieldsError())">Upravit</a-button>
        </div>
      </a-form>
    </div>
  </section>
</template>

<script>
import LanguageTab from '@/components/MyComponents/LanguageTab'
import ActionTools from '@/components/MyComponents/ActionTools'
import { hasErrors } from '../../../../services/forms'

export default {
  components: {
    ActionTools, LanguageTab,
  },
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  data() {
    return {
      hasErrors,
      id: this.$route.params.id,
      loading: false,
      routerOptions: [
        {
          icon: 'bars',
          theme: 'outlined',
          to: '/ecommerce/manufacturer',
          title: 'Seznam',
        },
      ],
      image: {
        switch: true,
        search: '',
        page: 1,
        loaded: false,
        errors: [],
      },
      item: {
        iae_id: {
          existing: null,
          new: [],
        },
        languages: [],
      },
      loaded: [],
    }
  },
  computed: {
    detail: function() {
      return this.$store.getters['manufacturer/getDetail']
    },
    images: function () {
      const images = this.$store.getters['image/filteredItems']({ searchText: this.image.search, page: this.image.page })
      if (this.item.iae_id.existing !== null) {
        const filteredData = images.data.filter(x => x.iae_id !== this.item.iae_id.existing.iae_id)
        return { count: images.count - (images.data.length - filteredData.length), data: filteredData }
      }
      return images
    },
    language: function () {
      return this.$store.getters['language/active']
    },
    imageNextCount: function () {
      const imageCount = this.images.count - this.images.data.length
      return imageCount > 6 ? 6 : imageCount
    },
  },
  methods: {
    refreshComponent(id) {
      this.id = id
      this.image = {
        switch: true,
        search: '',
        page: 1,
        loaded: false,
        errors: [],
      }
      this.item = {
        iae_id: {
          existing: null,
          new: [],
        },
        languages: [],
      }
      this.loaded = []
    },
    toImageName: function (name) {
      const maxLength = 30
      const nameSubstring = name.substring(0, maxLength)
      return nameSubstring.length !== maxLength ? nameSubstring : nameSubstring + '...'
    },
    onNextImagesClick() {
      this.image.page += 1
    },
    onImageSwitchChange(checked) {
      this.item.iae_id.new = []
      if (checked) {
        this.form.getFieldDecorator('existing', { initialValue: this.item.iae_id.existing !== null ? this.item.iae_id.existing.iae_id : undefined })
      }
    },
    initDetail() {
      this.loading = true
      this.$store.dispatch('manufacturer/getOne', this.id)
        .then(() => {
          const oldItem = this.item
          this.item = Object.assign({}, this.detail)
          this.item.iae_id = {
            existing: oldItem.iae_id.new.length > 0 ? null : oldItem.iae_id.existing !== null ? oldItem.iae_id.existing : this.detail.image,
            new: oldItem.iae_id.new,
          }
          const currentDetailLang = this.$store.getters['manufacturer/currentLanguageDetail']
          this.form.setFieldsValue({
            mle_description: currentDetailLang.mle_description,
            mur_name: this.item.mur_name,
            mur_url: this.item.mur_url,
            existing: this.item.iae_id.existing !== null ? this.item.iae_id.existing.iae_id : undefined,
          })
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
        })
    },
    initData() {
      this.loading = true
      Promise.all([
        this.$store.dispatch('image/getList'),
      ])
        .then(() => {
          this.initDetail()
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false
          this.loaded.push(this.language)
          this.image.loaded = true
        })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.handleChange(this.language)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.loading = true
          this.$store.dispatch('manufacturer/put', { id: this.id, item: this.getData() })
            .then((response) => {
              this.item.iae_id.existing = response.data.image
              this.form.getFieldDecorator('existing', { initialValue: response.data.image.iae_id })
            })
            .catch(() => {})
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    getData() {
      const data = new FormData()
      const jsonObject = {
        languages: this.item.languages.filter(x => x.mle_description !== undefined && x.mle_description.trim().length > 0),
        mur_name: this.form.getFieldValue('mur_name'),
        mur_url: this.form.getFieldValue('mur_url') === undefined || this.form.getFieldValue('mur_url').trim().length === 0 ? null : this.form.getFieldValue('mur_url'),
      }
      if (this.item.iae_id.new.length > 0) {
        data.append('image', this.item.iae_id.new[0], this.item.iae_id.new[0].name)
      } else {
        jsonObject.iae_id = this.form.getFieldValue('existing')
      }
      data.append('json', JSON.stringify(jsonObject))
      data.append('_method', 'PUT')
      return data
    },
    handleChange(oldLanguage) {
      const foundObj = { manufacturer: false }
      const newObj = {
        manufacturer: {
          lge_id: oldLanguage,
          mle_description: this.form.getFieldValue('mle_description'),
        },
      }
      this.item.languages.some((value, key) => {
        if (value.lge_id === oldLanguage) {
          this.item.languages[key] = newObj.manufacturer
          foundObj.manufacturer = true
          return true
        }
      })
      if (!foundObj.manufacturer) {
        this.item.languages.push(newObj.manufacturer)
      }
    },
    error(fieldName) {
      const { getFieldError, isFieldTouched } = this.form
      return isFieldTouched(fieldName) && getFieldError(fieldName)
    },
    beforeUpload(file) {
      this.item.iae_id.new = [file]
      return false
    },
    handleRemove() {
      this.item.iae_id.new = []
    },
  },
  created() {
    if (this.language !== null && !this.loaded.includes(this.language)) {
      this.initData()
    }
  },
  watch: {
    language(newValue, oldValue) {
      if (oldValue !== null && this.loaded.includes(oldValue)) {
        this.handleChange(oldValue)
      }
      if (newValue !== null) {
        if (!this.loaded.includes(this.language)) {
          this.initData()
        } else {
          const foundObj = {
            manufacturer: this.item.languages.find(x => x.lge_id === newValue),
          }
          const newObj = foundObj.manufacturer === undefined ? { mle_description: undefined } : { mle_description: foundObj.manufacturer.mle_description }
          this.form.setFieldsValue(newObj)
          if (!this.loaded.includes(this.language)) {
            this.initData()
          }
        }
        this.form.validateFields()
      }
    },
    '$route.params.id'(newId, oldId) {
      this.refreshComponent(newId)
      if (this.language !== null) {
        this.initDetail()
      }
    },
  },
}
</script>

<style lang="scss" module>
  @import "./style.module.scss";
</style>
